import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { ChromePicker } from 'react-color';
import SelectAsync from 'react-select/async';

export default class CrmCaseStatus extends Base {
    constructor(props) {
        super(props);
        this.state = {
            crmTeamId: props.CrmTeamId,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/crm/casestatus/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.order)) this.state.data.record.order = 0;

        this.httpPost("api/v1/crm/casestatus/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            hasDueDate: this.state.data.record.hasDueDate,
            hasAsignToPerson: this.state.data.record.hasAsignToPerson,
            color: this.state.data.record.color,
            order: this.state.data.record.order,
            crmTeamId: this.state.crmTeamId,
            responsiblePersonId: this.state.data.record.responsiblePersonId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    handleChangeComplete = (color) => {
        this.state.data.record.color = color.hex;
        this.setState({ data: this.state.data });
    }
    setHasAsignToPerson(e) {
        this.state.data.record.hasAsignToPerson = e;
        this.setState({ data: this.state.data });
    }
    setResponsiblePerson(e) {
        this.state.data.record.responsiblePersonId = e.value;
        this.state.data.record.responsiblePersonName = e.label;
    }
    renderForm() {
        if (this.state.data.record.id === this.defaultGuid() && !this.hasPermission(197)) return this.renderPermissionDenied();

        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                    {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات وضعیت" : "افزودن وضعیت جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                                <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">اولویت</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.order} onChange={e => this.state.data.record.order = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="6" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">تعیین مسئول</label>
                                            <select defaultValue={this.state.data.record.hasAsignToPerson} onChange={e => this.setHasAsignToPerson(parseInt(e.target.value))} type="text" className="form-control input-sm">
                                                <option value="0">فاقد مسئول</option>
                                                <option value="1">انتخاب مسئول توسط کاربر</option>
                                                <option value="2">حفظ مسئول از وضعیت قبلی</option>
                                                <option value="3">دارای مسئول اختصاصی</option>
                                            </select>
                                        </div>
                                    </div>
                                    {this.state.data.record.hasAsignToPerson === 3 && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">مسئول</label><span className="red">*</span>
                                            <SelectAsync
                                                defaultValue={this.state.data.record.responsiblePersonId === this.getDefaultGuid() ? null : { value: this.state.data.record.responsiblePersonId, label: this.state.data.record.responsiblePersonName }}
                                                style={{ "width": "100%" }}
                                                isMulti={false}
                                                placeholder="انتخاب مسئول"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 3)}
                                                onChange={e => this.setResponsiblePerson(e)}
                                            />
                                        </div>
                                    </div> }
                                    
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">زمان یادآوری</label>
                                            <select defaultValue={this.state.data.record.hasDueDate} onChange={e => this.state.data.record.hasDueDate = parseInt(e.target.value)} type="text" className="form-control input-sm">
                                                <option value="0">خیر</option>
                                                <option value="1">بله</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">رنگ زمینه کارت</label>
                                            <ChromePicker
                                                color={this.state.data.record.color}
                                                onChangeComplete={this.handleChangeComplete}
                                            />
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}